module.exports = __webpack_public_path__ + "static/media/27.121174e4.png";